import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from "@angular/router";
import { AppFooterComponent } from './app-footer/app-footer.component';
import { FaqComponent } from './faq/faq.component';
import { FaqAccountComponent } from './faq/faq-account/faq-account.component';
import { FaqOverviewComponent } from './faq/faq-overview/faq-overview.component';
import { FaqDashboardComponent } from './faq/faq-dashboard/faq-dashboard.component';
import { FaqProjectComponent } from './faq/faq-project/faq-project.component';
import { FaqReportComponent } from './faq/faq-report/faq-report.component';
import { FaqBilderComponent } from './faq/faq-admin-overview/faq-bilder/faq-bilder.component';
import { FaqSwaComponent } from './faq/faq-admin-overview/faq-swa/faq-swa.component';
import { FaqMenuComponent } from './faq/faq-menu/faq-menu.component';
import { FaqTimerSwitchComponent } from './faq/faq-admin-overview/faq-timer-switch/faq-timer-switch.component';
import { ImpressumComponent } from './impressum/impressum.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from "@angular/material/menu";
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from "@angular/material/button";
@NgModule({
    declarations: [
        AppFooterComponent,
        FaqComponent,
        FaqAccountComponent,
        FaqOverviewComponent,
        FaqDashboardComponent,
        FaqProjectComponent,
        FaqReportComponent,
        FaqBilderComponent,
        FaqSwaComponent,
        FaqMenuComponent,
        FaqTimerSwitchComponent,
        ImpressumComponent,
        PrivacyPolicyComponent

    ],
    imports: [
        SharedModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        MatDividerModule
    ],
    exports: [AppFooterComponent], 
    providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class CoreModule { }
